import { graphql } from 'react-relay';

export const tagListFragment = graphql`
    fragment tagListFragment on Query
    @argumentDefinitions(input: { type: "TagsFilteredListInput!" }, first: { type: "Int" }) {
        tagsFilteredList(input: $input, first: $first) @connection(key: "tagListFragment___tagsFilteredList") {
            edges {
                cursor
                node {
                    ...tagFragment
                }
            }
            ...tagConnectionFragment
        }
    }
`;
